import { UseRecordsOptions } from "../../api/useRecords";
import { FieldExtraOption } from "../../types/fields.types";
import { filterUsersRoles } from "../../utils/filterUsersRoles";

export const dayFieldsByFrequency: Record<string, Array<string>> = {
	daily: [],
	daily_no_sunday: [],
	weekly: ["run_at_weekdays"],
	monthly: ["run_at_monthdays"],
	monthly_week: ["run_at_weekdays", "run_at_week_ordinals"],
	annual: ["run_at_monthdays", "run_at_months"]
};

export const allDayFields = ["run_at_weekdays", "run_at_monthdays", "run_at_months", "run_at_week_ordinals"];

export const hasValue = (value: any) => {
	const isNonEmpty = Array.isArray(value) ? value.length > 0 : value != null && value !== "";
	return isNonEmpty;
};

const isScheduledTaskFormValid = (data: any) => {
	const requiredFields = dayFieldsByFrequency[data.run_at_frequency] ?? [];
	const hasAllRequired = requiredFields.every((field) => hasValue(data[field]));
	const validation = hasAllRequired
		? { valid: true }
		: { valid: false, message: "Preencha todos os campos do Agendamento." };
	return validation;
};

export const scheduledTasksOptions = {
	fieldsToRemove: {
		fieldNamesToRemove: ["id"],
		fieldTypesToRemove: []
	},

	groupsOptions: {
		fieldsWithExtraOptions: [
			{
				field: "assigned_users",
				relatedTable: "directus_users",
				displayTemplate: "{{first_name}} {{last_name}}",
				filter: filterUsersRoles,
				sort: "first_name,last_name",
				showM2OUserAvatar: true,
				enabled: true
			},
			{
				field: "participant_users",
				relatedTable: "directus_users",
				displayTemplate: "{{first_name}} {{last_name}}",
				filter: filterUsersRoles,
				sort: "first_name,last_name",
				enabled: true
			},
			{
				field: "next_run_at",
				hidden: { create: true, update: true },
				dateFormat: "dd/MM/yyyy"
			}
		],
		isFormValid: isScheduledTaskFormValid
	},

	dataGridOptions: {}
} as UseRecordsOptions;

const recurrenceFieldsToHideWhenEmpty = ["run_at_weekdays", "run_at_monthdays", "run_at_months", "run_at_week_ordinals", "due_hours"];

const hideWhenEmpty = (fieldName: string) => (item: any) => {
	const value = item?.[fieldName];
	return Array.isArray(value) ? value.length === 0 : value == null || value === "";
};

export const scheduledTasksDetailGroupsOptions = {
	...scheduledTasksOptions.groupsOptions,
	fieldsWithExtraOptions: [
		...(scheduledTasksOptions.groupsOptions?.fieldsWithExtraOptions ?? []),
		...recurrenceFieldsToHideWhenEmpty.map((field): FieldExtraOption => ({
			field,
			hidden: { detailFn: hideWhenEmpty(field) }
		}))
	]
};
